import styled from 'styled-components';
import { tokens } from '@plataforma/components';
import { Button as ButtonComponent } from 'junto-ui';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 864px;
  height: 184px;
  padding: ${tokens.spacing.l} ${tokens.spacing.xl};
  background: #8301da;
  border-radius: 4px;
`;

export const Logo = styled.img`
  .carousel .slide & {
    position: absolute;
    width: 139.99px;
    left: 681.75px;
    top: 42px;
  }
`;

export const Content = styled.div`
  margin: 46px 37px 0 53px;
`;

export const BannerText = styled.p`
  width: 393px;
  color: #ffffff;
  ${tokens.font['base-emphasys']};
  margin-bottom: ${tokens.spacing.m};

  strong {
    ${tokens.font['base-emphasys']}
  }
`;

export const Button = styled(ButtonComponent)`
  width: 176px;
  height: 32px;
  padding: 0;
  display: inline-block;
  margin-bottom: ${tokens.spacing.xl};
  border: 1px solid #ffffff;
  background-color: transparent;
`;
export const TextButton = styled.p`
  ${tokens.font.xs};
  color: #ffffff;
`;

export const ShapeContainer = styled.div`
  width: 207px;
  height: 103px;
`;

export const EndShape = styled.div`
  width: 341.2px;
  height: 200px;
  margin-right: -125px;
  margin-top: -50px;
  background: #eee;
  transform: skew(0.35rad);
`;
